module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/michal-paszkowski-fd9a663c147e5d7c8436dfb287557702.webp";